import React, { useEffect, useState } from "react";
import { styled } from "styled-components";
import { Color } from "../../../theme/Color";
import { Font } from "../../../theme/Font";
import { BigYellowLinkButton, TitleCTASec, TitleSection } from "../../DesignComponent/DesignComponents";
import SmallLogo from "../../../assets/NewSite/theleansuitelogo.png";
import BlogCTABg from "../../../assets/NewSite/BlogPostCTAsBG.png";
import SmallLeansuiteLogo from "../../../assets/NewSite/theleansuitelogo.png";
import axios from "axios";
import NewsLetterPopup from "./NewsLetterPopup";
import BlogAccess from "./BlogAccess";

const PostContainerContent = ({ key, item }) =>  (
  <div key={key}>
    {item?.title && (
      <TitleSection
        className="mb-4"
        style={{ color: Color.theme_first }}
        id={`${item.title
          .replace(/\s+/g, "-")
          .toLowerCase()}`}
      >
        {item?.title}
      </TitleSection>
    )}
    {item?.description && (
      <Description
        className="m-0"
        dangerouslySetInnerHTML={{
          __html: item?.description,
        }}
      />
    )}
    {item?.subtitle_content &&
      item?.subtitle_content.map((subtitle, idx) => (
        <div key={idx}>
          {subtitle?.subtitle && (
            <h3
              className="mt-4"
              style={{ color: Color.theme_first }}
            >
              {subtitle?.subtitle}
            </h3>
          )}
          {subtitle?.subtitle_description && (
            <Description
              className="m-0"
              dangerouslySetInnerHTML={{
                __html: subtitle?.subtitle_description,
              }}
            />
          )}
          {subtitle?.small_subtitle_content &&
            subtitle?.small_subtitle_content.map(
              (smallSubtitle, sIdx) => (
                <div key={sIdx}>
                  {smallSubtitle?.small_subtitle && (
                    <h4
                      className="mt-4"
                      style={{
                        color: Color.theme_first,
                      }}
                    >
                      {smallSubtitle?.small_subtitle}
                    </h4>
                  )}
                  {smallSubtitle?.small_subtitle_description && (
                    <Description
                      className="m-0"
                      dangerouslySetInnerHTML={{
                        __html:
                          smallSubtitle?.small_subtitle_description,
                      }}
                    />
                  )}
                  {smallSubtitle?.button && (
                    <LearMoreButton href={smallSubtitle?.button}>Learn More</LearMoreButton>
                  )}
                </div>
              )
            )}
          {subtitle?.button && (
            <LearMoreButton href={subtitle?.button}>Learn More</LearMoreButton>
          )}
        </div>
      ))}
    {item?.button && (
      <LearMoreButton href={item?.button}>Learn More</LearMoreButton>
    )}
  </div>
);

const PostContent = ({ data, singlepostdata }) => {
  const [showModal, setShowModal] = useState(false);
  const [pastDaysCount, setPastDaysCount] = useState(0);
  const [sheetData, setSheetData] = useState([]);
  const [isUserSignedUp, setIsUserSignedUp] = useState(false);
  const [ipAddress, setIPAddress] = useState("");

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const yOffset = -100;
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };
  const [activeSidebarIndex, setActiveSidebarIndex] = useState(0);
  const handleSidebarClick = (index, title) => {
    scrollToSection(title.replace(/\s+/g, "-").toLowerCase());
    window.removeEventListener("scroll", handleScroll);
    setActiveSidebarIndex(index);
  };
  const handleScroll = () => {
    const viewportTop = window.scrollY || window.pageYOffset;
    const viewportBottom = viewportTop + window.innerHeight;
    const sections =
      data?.title_and_description_content?.title_and_description || [];
    let lastInViewIndex = null;

    sections.forEach((section, index) => {
      const sectionId = section.title.replace(/\s+/g, "-").toLowerCase();
      const sectionElement = document.getElementById(sectionId);
      if (sectionElement) {
        const sectionTop = sectionElement.offsetTop;
        const sectionBottom = sectionTop + sectionElement.offsetHeight;

        // Check if the section is within the viewport
        if (sectionBottom >= viewportTop && sectionTop <= viewportBottom) {
          lastInViewIndex = index;
        }
      }
    });
    if (lastInViewIndex !== null) {
      setActiveSidebarIndex(lastInViewIndex);
    }
  };
  window.addEventListener("scroll", handleScroll);

  useEffect(() => {
    const publishedDate = new Date(singlepostdata.published_date);
    // const publishedDate = new Date("Feb 8, 2025");
    const currentDate = new Date();
    const timeDifference = currentDate - publishedDate;

    const daysPast = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    setPastDaysCount(daysPast);
  }, [singlepostdata]);

  useEffect(() => {
    if (!isUserSignedUp && pastDaysCount>5) {
      const timer = setTimeout(() => {
        setShowModal(true);
      }, 30000);
    } else setShowModal(false);

    // return () => clearTimeout(timer);
  }, [pastDaysCount, isUserSignedUp,showModal]);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const getSpreadsheetData = async () => {
    try {
      let response = await axios.get("https://theleansuite.com/api/blogs-sheet-data");
      setSheetData(response.data.data);
    } catch (error) {
      // console.error('Error adding row:', error);
    }
  };

  const getIpAdd = async () => {
    let response = await axios.get("https://api.ipify.org?format=json");
    setIPAddress(response.data.ip);
  };

  useEffect(() => {
     getIpAdd();
     getSpreadsheetData();
  }, []);

  useEffect(() => {
    let isExist = sheetData?.findIndex((data) => data.includes(ipAddress));
    if (isExist && isExist !== -1) {
      setIsUserSignedUp(true);
    }
  }, [sheetData]);

  return (
    <>
      <Section className="blog-content-sec">
        <div className="container">
          <div className="row justify-content-center">
            {data?.title_and_description_content?.title_and_description?.some(
              (item) => item.title
            ) && (
              <div className="col-md-3">
                <Sidebar>
                  <ListTitle
                    className="mb-4"
                    style={{ color: Color.theme_first }}
                  >
                    Table of Contents
                  </ListTitle>
                  <ul>
                    {data?.title_and_description_content
                      ?.title_and_description &&
                      data?.title_and_description_content?.title_and_description?.map(
                        (item, index) =>
                          item.title && (
                            <li
                              key={index}
                              className={`sidebar-title border-bottom ${
                                index === activeSidebarIndex ? "active" : ""
                              }`}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                handleSidebarClick(index, item.title);
                              }}
                            >
                              <div>{item.title}</div>
                            </li>
                          )
                      )}
                  </ul>
                  <BigYellowLinkButton
                    to={"/schedule-demo"}
                    className="mt-4"
                    style={{ minWidth: "100%", padding: "10px" }}
                  >
                    {"Schedule Demo"}
                  </BigYellowLinkButton>
                </Sidebar>
              </div>
            )}
            <div className="col-md-7 mx-auto">
              <div className="row">
                <div className="col-md-12">
                  <>
                    {data?.small_description && (
                      <Description
                        className="m-0"
                        dangerouslySetInnerHTML={{
                          __html: data?.small_description,
                        }}
                      />
                    )}
                    {data?.title_and_description_content
                      ?.title_and_description &&
                      data?.title_and_description_content?.title_and_description
                        .slice(0, 2)
                        .map((item, index) => (
                          <>
                            {pastDaysCount < 6 &&
                            !isUserSignedUp &&
                            index == 1 ? (
                              <BlogAccess 
                              ipAddress={ipAddress}
                              singlepostdata={singlepostdata}
                              getSpreadsheetData={getSpreadsheetData}
                              />
                            ) : null}
                            <div
                              style={
                                pastDaysCount < 6 &&
                                !isUserSignedUp &&
                                index > 0
                                  ? { filter: "blur(5px)" }
                                  : {}
                              }
                            >
                              <PostContainerContent key={index} item={item} />
                            </div>
                          </>
                        ))}
                    <Row48
                      className="row text-center justify-content-center my-4"
                      style={{
                        backgroundColor: Color.beige,
                        filter:
                          pastDaysCount < 6 && !isUserSignedUp
                            ? "blur(5px)"
                            : "none",
                      }}
                    >
                      <div className="col-md-11">
                        <img
                          src={SmallLogo}
                          alt={"theleansuite logo"}
                          className="w-auto mt-0 mb-4"
                        />
                        {singlepostdata?.categories && (
                          <TitleCTASec className="mb-4 mt-0">
                            {singlepostdata?.categories[0]?.description}
                          </TitleCTASec>
                        )}
                        <BigYellowLinkButton
                          to={"/schedule-demo"}
                          style={{ padding: "10px 30px", minWidth: "unset" }}
                        >
                          {"Schedule Demo"}
                        </BigYellowLinkButton>
                      </div>
                    </Row48>
                    {data?.title_and_description_content
                      ?.title_and_description &&
                      data?.title_and_description_content?.title_and_description
                        .slice(2)
                        .map((item, index) => (
                          <>
                            <div
                              style={{
                                // backgroundColor: Color.beige,
                                filter:
                                  (pastDaysCount < 6 && !isUserSignedUp)
                                    ? "blur(5px)"
                                    : "none",
                              }}
                            >
                              <PostContainerContent
                                key={index}
                                item={item}
                              />
                            </div>
                          </>
                        ))}
                  </>
                  {!singlepostdata?.categories
                    ?.map((cat) => cat.id)
                    .includes(1615) && (
                    <a
                      href="/schedule-demo"
                      style={{
                        filter:
                          pastDaysCount < 6 && !isUserSignedUp
                            ? "blur(5px)"
                            : "none",
                      }}
                      className="text-white text-decoration-none"
                    >
                      <div
                        className="cta-sec p-5 mt-4"
                        style={{
                          backgroundImage: `url(${BlogCTABg})`,
                          backgroundSize: "cover",
                        }}
                      >
                        <div className="d-flex justify-content-between">
                          <div className="content-wrapper w-75">
                            <TitleCTASec
                              className="mb-4 mt-0 text-white"
                              style={{ fontFamily: Font.medium }}
                            >
                              Leansuite: An end-to-end lean manufacturing
                              software
                            </TitleCTASec>
                            <BigYellowLinkButton
                              to={"/schedule-demo"}
                              style={{
                                padding: "10px 30px",
                                minWidth: "unset",
                              }}
                            >
                              {"Schedule Demo"}
                            </BigYellowLinkButton>
                          </div>
                          <div className="logo-wrapper">
                            <img
                              src={SmallLeansuiteLogo}
                              alt={"theleansuite logo"}
                              className="cta-smallicon"
                            />
                          </div>
                        </div>
                      </div>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>
      <NewsLetterPopup
        show={showModal}
        ipAddress={ipAddress}
        handleClose={handleCloseModal}
        getSpreadsheetData={getSpreadsheetData}
        singlepostdata={singlepostdata}
        pastDaysCount={pastDaysCount}
      />
    </>
  );
};

export default PostContent;

const Sidebar = styled.aside`
  position: sticky;
  top: 100px;
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    padding-top:16px;
    padding-bottom:16px;
    font-size: 16px;
    font-family: ${Font.basel};
    color: ${Color.lighterGrey};
    transition: 0.8s all ease;
    opacity:0.5;
    &.active {
      border-color: ${Color.text} !important;
      font-weight: bold;
    color: ${Color.text};
    opacity:1;
    }
    }
`;

const Section = styled.section`
  padding-top: 50px;
  padding-bottom: 50px;
  @media (max-width: 767px) {
    padding-top: 40px;
    padding-bottom: 40px;
  }
`;
const Row48 = styled.div`
  padding-top: 48px;
  padding-bottom: 48px;
  @media (max-width: 767px) {
    padding-top: 20px;
    padding-bottom: 20px;
  }
`;
const Description = styled.p`
  color: ${Color.lighterGrey};
  font-size: 16px;
  font-family: ${Font.basel};
  @media (max-width: 767px) {
    font-size: 16px;
  }
`;
const LearMoreButton = styled.a`
  background: ${Color.theme_first};
  font-size: 16px;
  font-weight: bold;
  font-family: ${Font.basel};
  color: ${Color.white};
  border: 1px solid ${Color.theme_first};
  padding: 10px 15px;
  box-shadow: none;
  border-radius: 4px;
  text-decoration: none;
  display: inline-block;
  &:hover {
    background-color: ${Color.white};
    color: ${Color.theme_first};
  }
  @media (max-width: 767px) {
    font-size: 16px;
    width: 90%;
  }
`;
const ListTitle = styled.h3`
  color: ${Color.black};
  font-family: ${Font.medium};
`;